import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = { class: "flex-1 max-w-sm" }


export default {
  __name: 'Alert',
  props: {
  type: {
    type: String,
    default: 'green',
    validator(value) {
      return ['red', 'green'].includes(value)
    }
  },
  message: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

return (_ctx, _cache) => {
  return (__props.message)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["flex gap-x-2 items-center rounded-xl px-4 py-2 text-sm leading-5 mb-4 l:mb-6", {
      'bg-clay-200 text-fir-900': __props.type === 'green',
      'bg-terra-900 bg-opacity-20 text-terra-900': __props.type === 'red',
    }])
      }, [
        (__props.type === 'green')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
              _createElementVNode("path", {
                d: "M12 22C11.4333 22 10.9542 21.8042 10.5625 21.4125C10.1708 21.0208 9.975 20.5417 9.975 19.975H14.025C14.025 20.5417 13.8292 21.0208 13.4375 21.4125C13.0458 21.8042 12.5667 22 12 22ZM7.95 18.425V16.925H16.05V18.425H7.95ZM8.075 15.4C6.975 14.6833 6.10417 13.7875 5.4625 12.7125C4.82083 11.6375 4.5 10.425 4.5 9.075C4.5 7.04166 5.24167 5.28333 6.725 3.8C8.20833 2.31666 9.96667 1.575 12 1.575C14.0333 1.575 15.7917 2.31666 17.275 3.8C18.7583 5.28333 19.5 7.04166 19.5 9.075C19.5 10.425 19.1833 11.6375 18.55 12.7125C17.9167 13.7875 17.0417 14.6833 15.925 15.4H8.075ZM8.625 13.9H15.4C16.2 13.3667 16.8333 12.675 17.3 11.825C17.7667 10.975 18 10.0583 18 9.075C18 7.425 17.4125 6.0125 16.2375 4.8375C15.0625 3.6625 13.65 3.075 12 3.075C10.35 3.075 8.9375 3.6625 7.7625 4.8375C6.5875 6.0125 6 7.425 6 9.075C6 10.0583 6.23333 10.975 6.7 11.825C7.16667 12.675 7.80833 13.3667 8.625 13.9Z",
                fill: "currentColor"
              }, null, -1 /* HOISTED */)
            ])))
          : _createCommentVNode("v-if", true),
        (__props.type === 'red')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[1] || (_cache[1] = [
              _createElementVNode("path", {
                d: "M1 21L12 2L23 21H1ZM3.6 19.5H20.4L12 5L3.6 19.5ZM12.1044 18.075C12.3181 18.075 12.4958 18.0027 12.6375 17.8581C12.7792 17.7135 12.85 17.5344 12.85 17.3206C12.85 17.1069 12.7777 16.9292 12.6331 16.7875C12.4885 16.6458 12.3094 16.575 12.0956 16.575C11.8819 16.575 11.7042 16.6473 11.5625 16.7919C11.4208 16.9365 11.35 17.1156 11.35 17.3294C11.35 17.5431 11.4223 17.7208 11.5669 17.8625C11.7115 18.0042 11.8906 18.075 12.1044 18.075ZM11.35 15.3H12.85V9.7H11.35V15.3Z",
                fill: "#A45944"
              }, null, -1 /* HOISTED */)
            ])))
          : _createCommentVNode("v-if", true),
        _createElementVNode("p", _hoisted_3, _toDisplayString(__props.message), 1 /* TEXT */)
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}
}

}